import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d567da46"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "#"),
    /*#__PURE__*/_createElementVNode("th", null, "FileName"),
    /*#__PURE__*/_createElementVNode("th", null, "Size"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, " No Items ", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onClick"]

import {ref, inject, computed} from "vue";
    import {key} from "@/components/FileManager";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'FileTable',
  setup(__props) {

    const fs = ref(inject(key));
    const keys = computed(()=>fs?.value?.keys());

    const removeFile = function(key:string){
        fs.value?.remove(key);
    }
    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", null, [
    _hoisted_1,
    _createElementVNode("tbody", null, [
      (_unref(keys) && _unref(keys).length == 0)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_2, _hoisted_4))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(fs.value?.keys(), (key, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: key }, [
              _createElementVNode("td", null, _toDisplayString(index+1), 1),
              _createElementVNode("td", null, _toDisplayString(fs.value?.files[key].file.name), 1),
              _createElementVNode("td", null, _toDisplayString(fs.value?.files[key].file.size), 1),
              _createElementVNode("td", null, _toDisplayString(fs.value?.files[key].status), 1),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (removeFile(key))
                }, "X", 8, _hoisted_5)
              ])
            ]))
          }), 128))
    ])
  ]))
}
}

})